export default "__VITE_ASSET__Cz4D9nRI__"